import React from 'react';

/**
 * Top header bar with title, location badge, and refresh button.
 */
function KasaBankHeader({ selectedLocation, loading, onRefresh }) {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '0.75rem',
      padding: '0.5rem 1rem',
      backgroundColor: 'var(--card-bg)',
      border: '1px solid var(--border)',
      borderRadius: '0.375rem',
      boxShadow: '0 1px 2px rgba(0,0,0,0.08)'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
        <span style={{ fontSize: '1rem' }}>💰</span>
        <h2 style={{ margin: 0, fontSize: '0.95rem', fontWeight: '600', color: 'var(--text)' }}>
          Kasa & Bank
        </h2>
        {selectedLocation && (
          <span style={{
            backgroundColor: 'var(--primary-light)',
            color: 'var(--primary)',
            padding: '0.2rem 0.5rem',
            borderRadius: '0.25rem',
            fontSize: '0.7rem',
            fontWeight: '500'
          }}>
            📍 {selectedLocation.name || selectedLocation.nazwa}
          </span>
        )}
      </div>
      <button
        onClick={onRefresh}
        disabled={loading}
        style={{
          padding: '6px 12px',
          fontSize: '12px',
          display: 'flex',
          alignItems: 'center',
          gap: '0.35rem',
          fontWeight: '500'
        }}
      >
        <i className={`fas ${loading ? 'fa-spinner fa-spin' : 'fa-sync-alt'}`} style={{ fontSize: '0.7rem' }}></i>
        {loading ? 'Ładowanie...' : 'Odśwież'}
      </button>
    </div>
  );
}

export default KasaBankHeader;
